export default __webpack_public_path__ + "static/media/coverVideo.321fe793.mp4";